import { createGlobalStyle } from "styled-components";
import button from "./button";
import message from "./message";
import rate from "./rate";
import select from "./select";
import input from "./input";
import floatButton from "./floatButton";

export default createGlobalStyle`
    ${button}
    ${message}
    ${rate}
    ${select}
    ${input}
    ${floatButton}
`;